const twoLinesHeight = 42

const NotificationHook = {
  mounted() {
    this.showingAll = false
    this.commentPaintZone = this.el.querySelector(".notification-slide-inner")

    const checkbox = this.el.querySelector('input[type="checkbox"]')
    checkbox.addEventListener("change", () => {
      this.showingAll = checkbox.checked
      this.onShowChange()
    })

    this.setupPaintArea()
  },

  updated() {
    const checkbox = this.el.querySelector('input[type="checkbox"]')
    checkbox.checked = this.showingAll
    this.onShowChange()
    this.setupPaintArea()
  },

  onShowChange() {
    if (this.showingAll) {
      this.commentPaintZone.classList.remove("notification-slide-inner")
      this.commentPaintZone.classList.add("line-clamp-none")
    } else {
      this.commentPaintZone.classList.add("notification-slide-inner")
      this.commentPaintZone.classList.remove("line-clamp-none")
    }
  },

  setupPaintArea() {
    this.observer = new IntersectionObserver(
      () => {
        const commentContent = this.el.querySelector(".ql-content")
        if (commentContent.scrollHeight === 0) return

        const commentTooLong =
          commentContent && commentContent.scrollHeight > twoLinesHeight

        if (!commentTooLong) {
          this.el.querySelector('[data-role="notification-toggle"]').remove()
        }

        this.observer.unobserve(this.commentPaintZone)
      },
      { threshold: 1.0 },
    )

    this.observer.observe(this.commentPaintZone)
  },
}

export { NotificationHook }
